import { ENDPOINTS } from 'config/endpoints';
import { QueryClient, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { Account } from 'crono-fe-common/types/account';
import { useLimitedMutation } from '../useLimitedMutation';
import { CreateAccountDTO } from 'crono-fe-common/types/DTO/createAccountDTO';
import { invalidateGetActiveAiVariableAnalyticsQuery } from '../assistant/useGetActiveAiVariableAnalytics';

export default function useCreateAccount() {
  const queryClient = useQueryClient();

  const createAccount = (data: CreateAccountDTO) => {
    const request: Request = {
      url: `${ENDPOINTS.account.main}`,
      config: {
        method: 'post',
        data: { ...data },
      },
    };
    return client(request);
  };

  return useLimitedMutation<
    Response<Account | null>,
    CronoError,
    CreateAccountDTO
  >(createAccount, {
    onSuccess: (_result, variables) => {
      invalidationUseCreateAccount(queryClient);
      if (variables.data.generateAiVariables?.externalPropertyIds?.length) {
        invalidateGetActiveAiVariableAnalyticsQuery(queryClient);
      }
    },
  });
}

export const invalidationUseCreateAccount = (queryClient: QueryClient) => {
  queryClient.invalidateQueries([ENDPOINTS.account.main]);
  queryClient.invalidateQueries([ENDPOINTS.account.search.main]);
  queryClient.invalidateQueries([ENDPOINTS.account.linkedin.main]);
  queryClient.invalidateQueries([ENDPOINTS.suggestion.search]);
  queryClient.invalidateQueries([ENDPOINTS.user.onboarding.features]);
};
